// cspell: ignore tinypass
import { isValidUrl } from "@product/scmp-sdk";
import { useMountEffect } from "@react-hookz/web";

import {
  registerMixPanelParameters,
  trackMixPanel,
  useMixpanel,
} from "scmp-app/components/mixpanel";
import { sendGTMSubscribeVariables } from "scmp-app/components/tracking/google-tag-manager/apis";
/**
 * Handle the tracking from Piano template
 * Both GTM and Mixpanel including impression and click
 */
export const useRosettaPianoTemplateTracking = () => {
  const mixpanel = useMixpanel();

  useMountEffect(() => {
    const handlePianoTemplateTracking = (event: Event) => {
      if (!isValidUrl(event.origin)) return;

      const hostname = new URL(event.origin).hostname;
      if (!(hostname.includes("piano") || hostname.includes("tinypass"))) {
        return;
      }

      if (event.data.type !== "tracking") return;

      const { gtm: gtmData, mixpanel: mixPanelData } = event.data;
      if (gtmData) {
        const { subscribe } = gtmData;
        subscribe && sendGTMSubscribeVariables(subscribe);
      }

      if (mixPanelData) {
        const { event, superProps } = mixPanelData;
        if (event) {
          const { name = "", props: property = {} } = event;
          name &&
            trackMixPanel(
              mixpanel.result,
              {
                name,
                property,
              },
              { untyped: true },
            );
        }
        superProps?.props && registerMixPanelParameters(mixpanel.result, superProps.props);
      }
    };

    window.addEventListener("message", handlePianoTemplateTracking);
    return () => {
      window.removeEventListener("message", handlePianoTemplateTracking);
    };
  });
};

type Event = {
  data: {
    gtm?: {
      subscribe?: Record<string, unknown>;
    };
    mixpanel?: {
      event?: {
        name?: string;
        props?: Record<string, unknown>;
      };
      superProps?: {
        props?: Record<string, unknown>;
      };
    };
    type?: string;
  };
  origin: string;
};
